// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// import Swiper and modules styles
/* eslint-disable import/no-unresolved */
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// init Swiper:
new Swiper('#top-carousel .swiper', {
  modules: [Navigation],
  centeredSlides: true,
  spaceBetween: 5,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  loop: true,
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1
    },
    // when window width is >= 600px
    600: {
      slidesPerView: 2
    },
    // when window width is >= 1024px
    1024: {
      slidesPerView: 3
    }
  }
});
